import React from 'react';
import { cn } from '@/lib/utils';

/** Max widths: the page's content (1680px plus the gutters), a 1050px centred intro, a 740px reading column. */
export const SITE_CONTAINER_WIDTHS = {
  canvas: 'max-w-canvas',
  narrow: 'max-w-[65.625rem]',
  prose: 'max-w-[46.25rem]',
  full: '',
};

/**
 * The redesign's inner container: centred, full width up to the chosen cap, with the
 * responsive page gutter (clamp(20px, 4vw, 64px) via `px-gutter`).
 *
 * Props:
 * - `width`: 'canvas' (default: 1680px of content) | 'narrow' (1050px) | 'prose' (740px) | 'full' (no cap)
 * - `as`: element or component (default 'div')
 * - `className`, `children`, any other prop is passed to the element.
 */
export default function SiteContainer({ as: Tag = 'div', width = 'canvas', className, children, ...rest }) {
  const w = Object.prototype.hasOwnProperty.call(SITE_CONTAINER_WIDTHS, width) ? width : 'canvas';
  return (
    <Tag className={cn('mx-auto w-full px-gutter', SITE_CONTAINER_WIDTHS[w], className)} {...rest}>
      {children}
    </Tag>
  );
}
